import axios from 'axios';

// Function to determine API base URL based on current origin
const getApiBaseUrl = () => {
  const origin = window.location.origin;
  
  // If localhost, use localhost:5000
  if (origin.includes('localhost')) {
    return 'https://stmarys-ioc-sa-backend.vercel.app/';
  }
  
  // For production, using Vercel backend URL
  return 'https://stmarys-ioc-sa-backend.vercel.app';
};

// Create axios instance with dynamic base URL
const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling and token refresh
api.interceptors.response.use(
  (response) => {
    // Check if server sent a new token
    const newToken = response.headers['x-new-token'];
    const tokenRefreshed = response.headers['x-token-refreshed'];
    
    if (newToken && tokenRefreshed === 'true') {
      console.log('✅ Token refreshed automatically');
      localStorage.setItem('token', newToken);
    }
    
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Only redirect if we're not already on the login page
      // This prevents infinite redirects during login attempts
      const currentPath = window.location.pathname;
      const isLoginPage = currentPath.includes('/login') || currentPath === '/admin/login';
      
      localStorage.removeItem('token');
      
      if (!isLoginPage) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { getApiBaseUrl };